import { Box, Button, Chip, Typography, useTheme } from '@mui/material';
import React from 'react';
import { CompanyType } from '../../../hooks/useSirenSearch';

export type CompanyCardProps = {
    company: CompanyType;
    onHideCard: (e: React.MouseEvent<HTMLElement>) => void;
};

const CompanyCard: React.FunctionComponent<CompanyCardProps> = function (props) {
    const { company, onHideCard } = props;
    const { palette } = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                rowGap: '0.5em',
                padding: '1em',
                borderRadius: '0.5em',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: palette.grey[300],
                backgroundColor: palette.grey[50],
            }}
        >
            <Box sx={{ display: 'flex', columnGap: '0.5em', alignItems: 'center' }}>
                <Typography variant="l2dbodyl">{company.denomination}</Typography>
                <Chip
                    label="Établissement principal"
                    color="success"
                />
            </Box>
            <Box sx={{ display: 'flex', columnGap: '0.5em', alignItems: 'center' }}>
                <Typography variant="l2dbodys">SIREN: {company.siren}</Typography>-
                <Typography variant="l2dbodys">SIRET: {company.siret}</Typography>
            </Box>
            <Box>Adresse: {company.addressFull}</Box>
            <Button
                data-testid="hide-company-card"
                variant="contained"
                sx={{ alignSelf: 'flex-start' }}
                onClick={onHideCard}
            >
                Changer d&lsquo;établissement
            </Button>
        </Box>
    );
};

export default CompanyCard;
